import React from 'react';
import { FaGithub, FaInstagram, FaTelegram, FaTwitter, FaSpotify } from 'react-icons/fa';

const HeaderSocials = () => {
    return (
        <div className='home__socials'>
            <a href='https://github.com/realmoneycold' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaGithub />
            </a>

            <a href='https://www.instagram.com/mon1ycold/' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaInstagram />
            </a>

            <a href='https://t.me/itzmon1ycold' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaTelegram />
            </a>

            <a href='https://x.com/mon1ycold?s=21' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaTwitter />
            </a>

            <a href='https://open.spotify.com/user/31ml2b6i3krphhi2fgu757rlgrie?si=Zvwz8BeIRUCr2qhz_FT3Yw' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaSpotify />
            </a>
        </div>
    );
};

export default HeaderSocials;
